import Vapi from 'vuex-rest-api'

import http from 'src/http/index'
import { beforeRequestReset, createSuccess, deleteSuccess, updateSuccess } from 'components/utils/storeUtils'

const initialState = () => ({
  inventarisaties: null,
  inventarisatie: {},
  bron_locatie_inventarisaties: null,
  bron_locatie_inventarisatie: {},
  bron_locaties: null,
  bron_locatie: {},
  bronnen: null,
  bron: {},
  bron_locatie_status: {},
  bron_locatie_fotos: null,
  bron_locatie_foto: {},
  bron_locatie_foto_tekeningen: null,
  bron_locatie_foto_tekening: {},
  bron_locatie_foto_verwijzingen: null,
  bron_locatie_foto_verwijzing: {},
  bron_monsters: null,
  beheersmaatregels: null,
  beheersmaatregel: {},
  bron_sanerings_advies: {},
  bron_sanerings_adviezen: null,
  monsters: null,
  monster: {},
  waarnemingen: null,
  waarneming: {},
  monster_analyses: null,
  monster_analyse: {},
  analyse_resultaten: null,
  analyse_resultaat: {},
  interviews: null,
  interview: {},
  onderzoek_beperkingen: null,
  onderzoek_beperking: {},
  documenten: null,
  document: {},
  lab_analyse_certificaten: null,
  lab_analyse_certificaat: {},
  inventarisatie_ruimtes: null,
  inventarisatie_ruimte: {},
  uitgesloten_ruimtes: null,
  uitgesloten_ruimte: {},
  out_of_scopes: null,
  out_of_scope: {},
  inventarisatie_user_certificates: null,
  inventarisatie_user_certificate: {},
  inventarisatie_user_capability_toewijzingen: null,
  inventarisatie_user_capability_toewijzing: {},
  uitrustingen: null,
  uitrusting: {},
  uitrusting_certificates: null,
  uitrusting_certificate: {}
})

const inventarisatieDepKeys = [
  'bronnen', 'bron', 'bron_locatie_status',
  'bron_locatie_inventarisaties', 'bron_locatie_inventarisatie',
  'bron_locaties', 'bron_locatie',
  'bron_locatie_fotos', 'bron_locatie_foto',
  'bron_locatie_foto_tekeningen', 'bron_locatie_foto_tekening',
  'bron_monsters', 'beheersmaatregels', 'beheersmaatregel',
  'monsters', 'monster',
  'monster_analyses', 'monster_analyse',
  'interviews', 'interview',
  'onderzoek_beperkingen', 'onderzoek_beperking',
  'documenten', 'document',
  'lab_analyse_certificaten', 'lab_analyse_certificaat',
  'inventarisatie_ruimtes', 'inventarisatie_ruimte'
]

const bronDepKeys = [
  'bron_locaties', 'bron_locatie',
  'bron_locatie_status',
  'bron_locatie_inventarisaties', 'bron_locatie_inventarisatie',
  'bron_locatie_fotos', 'bron_locatie_foto',
  'bron_locatie_foto_tekeningen', 'bron_locatie_foto_tekening',
  'bron_monsters', 'beheersmaatregels', 'beheersmaatregel',
  'monster'
]

const bronlocatieDepKeys = [
  'bron_locatie_status',
  'bron_locatie_inventarisaties', 'bron_locatie_inventarisatie',
  'bron_locatie_fotos', 'bron_locatie_foto',
  'bron_locatie_foto_tekeningen', 'bron_locatie_foto_tekening',
  'bron_monsters', 'beheersmaatregels', 'beheersmaatregel',
  'monster'
]

const bronFotoDepKeys = [
  'bron_locatie_foto_tekeningen', 'bron_locatie_foto_tekening'
]

const monsterDepKeys = [
  'monster_analyses', 'monster_analyse', 'analyse_resultaten', 'analyse_resultaat'
]

const inventarisatie = new Vapi({
  axios: http.axios,
  baseURL: process.env.API_URL + '/inventarisatie',
  queryParams: true,
  state: initialState()
})
  .get({
    action: 'GET_INVENTARISATIES_FROM_ONDERZOEK',
    property: 'inventarisaties',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/inventarisaties`
  })
  .get({
    action: 'GET_INVENTARISATIE',
    property: 'inventarisatie',
    queryParams: true,
    path: ({ id }) => `/inventarisatie/${id}`,
    beforeRequest: beforeRequestReset('inventarisatie', inventarisatieDepKeys, initialState())
  })
  .post({
    action: 'CREATE_INVENTARISATIE',
    property: 'inventarisatie',
    path: '/inventarisatie',
    queryParams: true,
    onSuccess: createSuccess('inventarisatie', 'inventarisaties')
  })
  .post({
    action: 'UPDATE_INVENTARISATIE',
    property: 'inventarisatie',
    queryParams: true,
    path: ({ id }) => `/inventarisatie/${id}`,
    onSuccess: updateSuccess('inventarisatie', 'inventarisaties')
  })
  .delete({
    action: 'DELETE_INVENTARISATIE',
    property: 'inventarisatie',
    queryParams: true,
    path: ({ id }) => `/inventarisatie/${id}`,
    onSuccess: deleteSuccess('inventarisatie')
  })
  .post({
    action: 'UPDATE_INVENTARISATIE_ASSET',
    property: 'inventarisatie_asset',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_asset/${id}`,
    onSuccess: updateSuccess('inventarisatie_asset', 'inventarisatie_assets')
  })
  .get({
    action: 'GET_BRON_LOCATIE_INVENTARISATIES_FROM_ONDERZOEK',
    property: 'bron_locatie_inventarisaties',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/inventarisaties/bron_locatie_inventarisaties`
  })
  .get({
    action: 'GET_BRON_LOCATIE_INVENTARISATIE',
    property: 'bron_locatie_inventarisatie',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_inventarisatie/${id}`
  })
  .post({
    action: 'CREATE_BRON_LOCATIE_INVENTARISATIE',
    property: 'bron_locatie_inventarisatie',
    path: '/bron_locatie_inventarisatie',
    queryParams: true,
    onSuccess: createSuccess('bron_locatie_inventarisatie', 'bron_locatie_inventarisaties')
  })
  .post({
    action: 'UPDATE_BRON_LOCATIE_INVENTARISATIE',
    property: 'bron_locatie_inventarisatie',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_inventarisatie/${id}`,
    onSuccess: updateSuccess('bron_locatie_inventarisatie', 'bron_locatie_inventarisaties')
  })
  .delete({
    action: 'DELETE_BRON_LOCATIE_INVENTARISATIE',
    property: 'bron_locatie_inventarisatie',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_inventarisatie/${id}`,
    onSuccess: deleteSuccess('bron_locatie_inventarisatie')
  })
  .get({
    action: 'GET_BRONNEN_FROM_ONDERZOEK',
    property: 'bronnen',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/inventarisaties/bron_locatie_inventarisaties/bron_locatie/bron`
  })
  .get({
    action: 'GET_BRON',
    property: 'bron',
    queryParams: true,
    path: ({ id }) => `/bron/${id}`,
    beforeRequest: beforeRequestReset('bron', bronDepKeys, initialState())
  })
  .post({
    action: 'CREATE_BRON',
    property: 'bron',
    path: '/bron',
    queryParams: true,
    onSuccess: createSuccess('bron', 'bronnen')
  })
  .post({
    action: 'UPDATE_BRON',
    property: 'bron',
    queryParams: true,
    path: ({ id }) => `/bron/${id}`,
    onSuccess: updateSuccess('bron', 'bronnen')
  })
  .delete({
    action: 'DELETE_BRON',
    property: 'bron',
    queryParams: true,
    path: ({ id }) => `/bron/${id}`,
    onSuccess: deleteSuccess('bron')
  })
  .get({
    action: 'GET_BRON_LOCATIES_FROM_ONDERZOEK',
    property: 'bron_locaties',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/inventarisaties/bron_locatie_inventarisaties/bron_locatie`
  })
  .get({
    action: 'GET_BRON_LOCATIES_FROM_BRON',
    property: 'bron_locaties',
    queryParams: true,
    path: ({ bronId }) => `/bron/${bronId}/bron_locaties`
  })
  .get({
    action: 'GET_BRON_LOCATIE',
    property: 'bron_locatie',
    queryParams: true,
    path: ({ id }) => `/bron_locatie/${id}`,
    beforeRequest: beforeRequestReset('bron_locatie', bronlocatieDepKeys, initialState())
  })
  .post({
    action: 'CREATE_BRON_LOCATIE',
    property: 'bron_locatie',
    path: '/bron_locatie',
    queryParams: true,
    onSuccess: createSuccess('bron_locatie', 'bron_locaties')
  })
  .post({
    action: 'UPDATE_BRON_LOCATIE',
    property: 'bron_locatie',
    queryParams: true,
    path: ({ id }) => `/bron_locatie/${id}`,
    onSuccess: updateSuccess('bron_locatie', 'bron_locaties')
  })
  .delete({
    action: 'DELETE_BRON_LOCATIE',
    property: 'bron_locatie',
    queryParams: true,
    path: ({ id }) => `/bron_locatie/${id}`,
    onSuccess: deleteSuccess('bron_locatie')
  })
  .get({
    action: 'GET_BRON_LOCATIE_STATUS',
    property: 'bron_locatie_status',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_status/${id}`
  })
  .post({
    action: 'CREATE_BRON_LOCATIE_STATUS',
    property: 'bron_locatie_status',
    path: '/bron_locatie_status',
    queryParams: true,
    onSuccess: createSuccess('bron_locatie_status', 'bron_locatie_statussen')
  })
  .post({
    action: 'UPDATE_BRON_LOCATIE_STATUS',
    property: 'bron_locatie_status',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_status/${id}`,
    onSuccess: updateSuccess('bron_locatie_status', 'bron_locatie_statussen')
  })
  .delete({
    action: 'DELETE_BRON_LOCATIE_STATUS',
    property: 'bron_locatie_status',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_status/${id}`,
    onSuccess: deleteSuccess('bron_locatie_status')
  })
  .get({
    action: 'GET_BRON_SANERINGS_ADVIEZEN_FROM_STATUS',
    property: 'bron_sanerings_adviezen',
    queryParams: true,
    path: ({ id }) => `bron_locatie_status/${id}/sanerings_adviezen`
  })
  .get({
    action: 'GET_BRON_SANERINGS_ADVIES',
    property: 'bron_sanerings_advies',
    queryParams: true,
    path: ({ id }) => `/bron_sanerings_advies/${id}`
  })
  .post({
    action: 'CREATE_BRON_SANERINGS_ADVIES',
    property: 'bron_sanerings_advies',
    path: '/bron_sanerings_advies',
    queryParams: true,
    onSuccess: createSuccess('bron_sanerings_advies', 'bron_sanerings_adviezen')
  })
  .post({
    action: 'UPDATE_BRON_SANERINGS_ADVIES',
    property: 'bron_sanerings_advies',
    queryParams: true,
    path: ({ id }) => `/bron_sanerings_advies/${id}`,
    onSuccess: updateSuccess('bron_sanerings_advies', 'bron_sanerings_adviezen')
  })
  .delete({
    action: 'DELETE_BRON_SANERINGS_ADVIES',
    property: 'bron_sanerings_advies',
    queryParams: true,
    path: ({ id }) => `/bron_sanerings_advies/${id}`,
    onSuccess: deleteSuccess('bron_sanerings_advies')
  })
  .get({
    action: 'GET_BEHEERSMAATREGELS_FROM_STATUS',
    property: 'beheersmaatregels',
    queryParams: true,
    path: ({ id }) => `bron_locatie_status/${id}/beheersmaatregels`
  })
  .get({
    action: 'GET_BEHEERSMAATREGEL',
    property: 'beheersmaatregel',
    queryParams: true,
    path: ({ id }) => `/beheersmaatregel/${id}`
  })
  .post({
    action: 'CREATE_BEHEERSMAATREGEL',
    property: 'beheersmaatregel',
    path: '/beheersmaatregel',
    queryParams: true,
    onSuccess: createSuccess('beheersmaatregel', 'beheersmaatregels')
  })
  .post({
    action: 'UPDATE_BEHEERSMAATREGEL',
    property: 'beheersmaatregel',
    queryParams: true,
    path: ({ id }) => `/beheersmaatregel/${id}`,
    onSuccess: updateSuccess('beheersmaatregel', 'beheersmaatregels')
  })
  .delete({
    action: 'DELETE_BEHEERSMAATREGEL',
    property: 'beheersmaatregel',
    queryParams: true,
    path: ({ id }) => `/beheersmaatregel/${id}`,
    onSuccess: deleteSuccess('beheersmaatregel')
  })
  .get({
    action: 'GET_WAARNEMINGEN_FROM_BRON',
    property: 'bron_waarnemingen',
    queryParams: true,
    path: ({ bronId }) => `/bron/${bronId}/bron_locaties/bron_locatie_inventarisaties/waarnemingen`
  })
  .get({
    action: 'GET_WAARNEMINGEN_FROM_CONTROLE',
    property: 'controle_waarnemingen',
    queryParams: true,
    path: ({ controleId }) => `/controle/${controleId}/waarnemingen`
  })
  .get({
    action: 'GET_WAARNEMINGEN_FROM_BRON_LOCATIE',
    property: 'waarnemingen',
    queryParams: true,
    path: ({ id }) => `/bron_locatie/${id}/bron_locatie_inventarisaties/waarnemingen`
  })
  .get({
    action: 'GET_WAARNEMINGEN_FROM_ONDERZOEK',
    property: 'waarnemingen',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/inventarisaties/bron_locatie_inventarisaties/waarnemingen`
  })
  .get({
    action: 'GET_WAARNEMING',
    property: 'waarneming',
    queryParams: true,
    path: ({ id }) => `/waarneming/${id}`,
    beforeRequest: beforeRequestReset('waarneming', monsterDepKeys, initialState())
  })
  .post({
    action: 'CREATE_WAARNEMING',
    property: 'waarneming',
    path: '/waarneming',
    queryParams: true,
    onSuccess: createSuccess('waarneming', 'waarnemingen')
  })
  .post({
    action: 'UPDATE_WAARNEMING',
    property: 'waarneming',
    queryParams: true,
    path: ({ id }) => `/waarneming/${id}`
  })
  .delete({
    action: 'DELETE_WAARNEMING',
    property: 'waarneming',
    queryParams: true,
    path: ({ id }) => `/waarneming/${id}`,
    onSuccess: deleteSuccess('waarneming', 'waarnemings')
  })
  .get({
    action: 'GET_MONSTERS_FROM_BRON',
    property: 'bron_monsters',
    queryParams: true,
    path: ({ bronId }) => `/bron/${bronId}/bron_locaties/bron_locatie_inventarisaties/monsters`
  })
  .get({
    action: 'GET_MONSTERS_FROM_BRON_LOCATIE',
    property: 'bron_monsters',
    queryParams: true,
    path: ({ bronLocatieId }) => `/bron_locatie/${bronLocatieId}/bron_locatie_inventarisaties/monsters`
  })
  .get({
    action: 'GET_MONSTERS_FROM_ONDERZOEK',
    property: 'monsters',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/inventarisaties/bron_locatie_inventarisaties/monsters`
  })
  .get({
    action: 'GET_MONSTER',
    property: 'monster',
    queryParams: true,
    path: ({ id }) => `/monster/${id}`,
    beforeRequest: beforeRequestReset('monster', monsterDepKeys, initialState())
  })
  .post({
    action: 'CREATE_MONSTER',
    property: 'monster',
    path: '/monster',
    queryParams: true,
    onSuccess: createSuccess('monster', 'monsters')
  })
  .post({
    action: 'UPDATE_MONSTER',
    property: 'monster',
    queryParams: true,
    path: ({ id }) => `/monster/${id}`,
    onSuccess: updateSuccess('monster', 'monsters')
  })
  .delete({
    action: 'DELETE_MONSTER',
    property: 'monster',
    queryParams: true,
    path: ({ id }) => `/monster/${id}`,
    onSuccess: deleteSuccess('monster')
  })
  .get({
    action: 'GET_MONSTER_ANALYSES',
    property: 'monster_analyses',
    queryParams: true,
    path: ({ monsterId }) => `/monster/${monsterId}/monster_analyses`
  })
  .get({
    action: 'GET_MONSTER_ANALYSE',
    property: 'monster_analyse',
    queryParams: true,
    path: ({ id }) => `/monster_analyse/${id}`
  })
  .post({
    action: 'CREATE_MONSTER_ANALYSE',
    property: 'monster_analyse',
    path: '/monster_analyse',
    queryParams: true,
    onSuccess: createSuccess('monster_analyse', 'monster_analyses')
  })
  .post({
    action: 'UPDATE_MONSTER_ANALYSE',
    property: 'monster_analyse',
    queryParams: true,
    path: ({ id }) => `/monster_analyse/${id}`,
    onSuccess: updateSuccess('monster_analyse', 'monster_analyses')
  })
  .delete({
    action: 'DELETE_MONSTER_ANALYSE',
    property: 'monster_analyse',
    queryParams: true,
    path: ({ id }) => `/monster_analyse/${id}`,
    onSuccess: deleteSuccess('monster_analyses')
  })
  .get({
    action: 'GET_ANALYSE_RESULTATEN',
    property: 'analyse_resultaten',
    queryParams: true,
    path: ({ analyseId }) => `/monster_analyse/${analyseId}/analyse_resultaten`
  })
  .get({
    action: 'GET_ANALYSE_RESULTAAT',
    property: 'analyse_resultaat',
    queryParams: true,
    path: ({ id }) => `/analyse_resultaat/${id}`
  })
  .post({
    action: 'CREATE_ANALYSE_RESULTAAT',
    property: 'analyse_resultaat',
    path: '/analyse_resultaat',
    queryParams: true,
    onSuccess: createSuccess('analyse_resultaat', 'analyse_resultaten')
  })
  .post({
    action: 'UPDATE_ANALYSE_RESULTAAT',
    property: 'analyse_resultaat',
    path: ({ id }) => `/analyse_resultaat/${id}`,
    onSuccess: updateSuccess('analyse_resultaat', 'analyse_resultaten')
  })
  .delete({
    action: 'DELETE_ANALYSE_RESULTAAT',
    property: 'analyse_resultaat',
    queryParams: true,
    path: ({ id }) => `/analyse_resultaat/${id}`,
    onSuccess: deleteSuccess('analyse_resultaat')
  })
  .get({
    action: 'GET_INTERVIEWS_FROM_ONDERZOEK',
    property: 'interviews',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/interviews`
  })
  .get({
    action: 'GET_INTERVIEW',
    property: 'interview',
    queryParams: true,
    path: ({ id }) => `/interview/${id}`
  })
  .post({
    action: 'CREATE_INTERVIEW',
    property: 'interview',
    path: '/interview',
    queryParams: true,
    onSuccess: createSuccess('interview', 'interviews')
  })
  .post({
    action: 'UPDATE_INTERVIEW',
    property: 'interview',
    queryParams: true,
    path: ({ id }) => `/interview/${id}`,
    onSuccess: updateSuccess('interview', 'interviews')
  })
  .delete({
    action: 'DELETE_INTERVIEW',
    property: 'interview',
    queryParams: true,
    path: ({ id }) => `/interview/${id}`,
    onSuccess: deleteSuccess('interview')
  })
  .get({
    action: 'GET_ONDERZOEK_BEPERKINGEN_FROM_ONDERZOEK',
    property: 'onderzoek_beperkingen',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/onderzoek_beperkingen`
  })
  .get({
    action: 'GET_ONDERZOEK_BEPERKING',
    property: 'onderzoek_beperking',
    queryParams: true,
    path: ({ id }) => `/onderzoek_beperking/${id}`
  })
  .post({
    action: 'CREATE_ONDERZOEK_BEPERKING',
    property: 'onderzoek_beperking',
    path: '/onderzoek_beperking',
    queryParams: true,
    onSuccess: createSuccess('onderzoek_beperking', 'onderzoek_beperkingen')
  })
  .post({
    action: 'UPDATE_ONDERZOEK_BEPERKING',
    property: 'onderzoek_beperking',
    queryParams: true,
    path: ({ id }) => `/onderzoek_beperking/${id}`,
    onSuccess: updateSuccess('onderzoek_beperking', 'onderzoek_beperkingen')
  })
  .delete({
    action: 'DELETE_ONDERZOEK_BEPERKING',
    property: 'onderzoek_beperking',
    queryParams: true,
    path: ({ id }) => `/onderzoek_beperking/${id}`,
    onSuccess: deleteSuccess('onderzoek_beperking')
  })
  .get({
    action: 'GET_DOCUMENTEN_FROM_ONDERZOEK',
    property: 'documenten',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/documenten`
  })
  .get({
    action: 'GET_DOCUMENT',
    property: 'document',
    queryParams: true,
    path: ({ id }) => `/document/${id}`
  })
  .post({
    action: 'CREATE_DOCUMENT',
    property: 'document',
    path: '/document',
    queryParams: true,
    onSuccess: createSuccess('document', 'documenten')
  })
  .post({
    action: 'UPDATE_DOCUMENT',
    property: 'document',
    queryParams: true,
    path: ({ id }) => `/document/${id}`,
    onSuccess: updateSuccess('document', 'documenten')
  })
  .delete({
    action: 'DELETE_DOCUMENT',
    property: 'document',
    queryParams: true,
    path: ({ id }) => `/document/${id}`,
    onSuccess: deleteSuccess('document')
  })
  .get({
    action: 'GET_LAB_ANALYSE_CERTIFICATEN_FROM_ONDERZOEK',
    property: 'lab_analyse_certificaten',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/onderzoeks_laboratoria/lab_orders/lab_analyse_certificaten`,
    beforeRequest: beforeRequestReset('lab_analyse_certificaat', ['lab_analyse_certificaat'], initialState())
  })
  .get({
    action: 'GET_LAB_ANALYSE_CERTIFICATEN_FROM_ONDERZOEKS_LABORATORIUM',
    property: 'lab_analyse_certificaten',
    queryParams: true,
    path: ({ id }) => `/onderzoeks_laboratorium/${id}/lab_orders/lab_analyse_certificaten`,
    beforeRequest: beforeRequestReset('lab_analyse_certificaat', ['lab_analyse_certificaat'], initialState())
  })
  .get({
    action: 'GET_LAB_ANALYSE_CERTIFICAAT',
    property: 'lab_analyse_certificaat',
    queryParams: true,
    path: ({ id }) => `/lab_analyse_certificaat/${id}`
  })
  .post({
    action: 'CREATE_LAB_ANALYSE_CERTIFICAAT',
    property: 'lab_analyse_certificaat',
    path: '/lab_analyse_certificaat',
    queryParams: true,
    onSuccess: createSuccess('lab_analyse_certificaat', 'lab_analyse_certificaten')
  })
  .post({
    action: 'UPDATE_LAB_ANALYSE_CERTIFICAAT',
    property: 'lab_analyse_certificaat',
    queryParams: true,
    path: ({ id }) => `/lab_analyse_certificaat/${id}`,
    onSuccess: updateSuccess('lab_analyse_certificaat', 'lab_analyse_certificaten')
  })
  .delete({
    action: 'DELETE_LAB_ANALYSE_CERTIFICAAT',
    property: 'lab_analyse_certificaat',
    queryParams: true,
    path: ({ id }) => `/lab_analyse_certificaat/${id}`,
    onSuccess: deleteSuccess('lab_analyse_certificaat')
  })
  .get({
    action: 'GET_FOTO_VERWIJZINGEN_FROM_MONSTER',
    property: 'foto_verwijzingen',
    queryParams: true,
    path: ({ id }) => `/monster/${id}/foto_verwijzingen`
  })
  .get({
    action: 'GET_FOTO_VERWIJZINGEN_FROM_WAARNEMING',
    property: 'foto_verwijzingen',
    queryParams: true,
    path: ({ id }) => `/waarneming/${id}/foto_verwijzingen`
  })
  .get({
    action: 'GET_FOTO_VERWIJZING',
    property: 'foto_verwijzing',
    queryParams: true,
    path: ({ id }) => `/foto_verwijzing/${id}`
  })
  .post({
    action: 'CREATE_FOTO_VERWIJZING',
    property: 'foto_verwijzing',
    path: '/foto_verwijzing',
    queryParams: true,
    onSuccess: createSuccess('foto_verwijzing', 'foto_verwijzingen')
  })
  .post({
    action: 'UPDATE_FOTO_VERWIJZING',
    property: 'foto_verwijzing',
    queryParams: true,
    path: ({ id }) => `/foto_verwijzing/${id}`,
    onSuccess: updateSuccess('foto_verwijzing', 'foto_verwijzingen')
  })
  .delete({
    action: 'DELETE_FOTO_VERWIJZING',
    property: 'foto_verwijzing',
    queryParams: true,
    path: ({ id }) => `/foto_verwijzing/${id}`,
    onSuccess: deleteSuccess('foto_verwijzing')
  })
  .get({
    action: 'GET_FOTOS_FROM_BRON_LOCATIE',
    property: 'bron_locatie_fotos',
    queryParams: true,
    path: ({ bronId }) => `/bron_locatie/${bronId}/bron_locatie_inventarisaties/bron_locatie_fotos`
  })
  .get({
    action: 'GET_BRON_LOCATIE_FOTO',
    property: 'bron_locatie_foto',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_foto/${id}`,
    beforeRequest: beforeRequestReset('bron_locatie_foto', bronFotoDepKeys, initialState())
  })
  .post({
    action: 'CREATE_BRON_LOCATIE_FOTO',
    property: 'bron_locatie_foto',
    path: '/bron_locatie_foto',
    queryParams: true,
    onSuccess: createSuccess('bron_locatie_foto', 'bron_locatie_fotos')
  })
  .post({
    action: 'UPDATE_BRON_LOCATIE_FOTO',
    property: 'bron_locatie_foto',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_foto/${id}`,
    onSuccess: updateSuccess('bron_locatie_foto', 'bron_locatie_fotos')
  })
  .delete({
    action: 'DELETE_BRON_LOCATIE_FOTO',
    property: 'bron_locatie_foto',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_foto/${id}`,
    onSuccess: deleteSuccess('bron_locatie_foto')
  })
  .get({
    action: 'GET_BRON_LOCATIE_FOTO_TEKENING',
    property: 'bron_locatie_foto_tekening',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_foto_tekening/${id}`
  })
  .post({
    action: 'CREATE_BRON_LOCATIE_FOTO_TEKENING',
    property: 'bron_locatie_foto_tekening',
    path: '/bron_locatie_foto_tekening',
    queryParams: true,
    onSuccess: createSuccess('bron_locatie_foto_tekening', 'bron_locatie_foto_tekeningen')
  })
  .post({
    action: 'UPDATE_BRON_LOCATIE_FOTO_TEKENING',
    property: 'bron_locatie_foto_tekening',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_foto_tekening/${id}`,
    onSuccess: updateSuccess('bron_locatie_foto_tekening', 'bron_locatie_foto_tekeningen')
  })
  .delete({
    action: 'DELETE_BRON_LOCATIE_FOTO_TEKENING',
    property: 'bron_locatie_foto_tekening',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_foto_tekening/${id}`,
    onSuccess: deleteSuccess('bron_locatie_foto_tekening')
  })
  .get({
    action: 'GET_INVENTARISATIE_RUIMTES_FROM_ONDERZOEK',
    queryParams: true,
    property: 'inventarisatie_ruimtes',
    path: ({ id }) => `onderzoek/${id}/inventarisatie_asset/inventarisatie_ruimtes`
  })
  .get({
    action: 'GET_INVENTARISATIE_RUIMTES',
    queryParams: true,
    property: 'inventarisatie_ruimtes',
    path: '/inventarisatie_ruimte'
  })
  .get({
    action: 'GET_INVENTARISATIE_RUIMTE',
    property: 'inventarisatie_ruimte',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_ruimte/${id}`
  })
  .post({
    action: 'CREATE_INVENTARISATIE_RUIMTE',
    property: 'inventarisatie_ruimte',
    path: '/inventarisatie_ruimte',
    queryParams: true,
    onSuccess: createSuccess('inventarisatie_ruimte', 'inventarisatie_ruimtes')
  })
  .post({
    action: 'UPDATE_INVENTARISATIE_RUIMTE',
    property: 'inventarisatie_ruimte',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_ruimte/${id}`,
    onSuccess: updateSuccess('inventarisatie_ruimte', 'inventarisatie_ruimtes')
  })
  .delete({
    action: 'DELETE_INVENTARISATIE_RUIMTE',
    property: 'inventarisatie_ruimte',
    requestConfig: {
      headers: {
        'X-Strmln-Forced-Delete': true
      }
    },
    queryParams: true,
    path: ({ id }) => `/inventarisatie_ruimte/${id}`,
    onSuccess: deleteSuccess('inventarisatie_ruimte')
  })
  .get({
    action: 'GET_OUT_OF_SCOPES_FROM_ONDERZOEK',
    queryParams: true,
    property: 'out_of_scopes',
    path: ({ id }) => `onderzoek/${id}/out_of_scopes`
  })
  .get({
    action: 'GET_UITGESLOTEN_RUIMTES_FROM_ONDERZOEK',
    queryParams: true,
    property: 'uitgesloten_ruimtes',
    path: ({ id }) => `onderzoek/${id}/uitgesloten_ruimtes`
  })
  .get({
    action: 'GET_UITGESLOTEN_RUIMTES',
    queryParams: true,
    property: 'uitgesloten_ruimtes',
    path: '/uitgesloten_ruimte'
  })
  .get({
    action: 'GET_UITGESLOTEN_RUIMTE',
    property: 'uitgesloten_ruimte',
    queryParams: true,
    path: ({ id }) => `/uitgesloten_ruimte/${id}`
  })
  .post({
    action: 'CREATE_UITGESLOTEN_RUIMTE',
    property: 'uitgesloten_ruimte',
    path: '/uitgesloten_ruimte',
    queryParams: true,
    onSuccess: createSuccess('uitgesloten_ruimte', 'uitgesloten_ruimtes')
  })
  .post({
    action: 'UPDATE_UITGESLOTEN_RUIMTE',
    property: 'uitgesloten_ruimte',
    queryParams: true,
    path: ({ id }) => `/uitgesloten_ruimte/${id}`,
    onSuccess: updateSuccess('uitgesloten_ruimte', 'uitgesloten_ruimten')
  })
  .delete({
    action: 'DELETE_UITGESLOTEN_RUIMTE',
    property: 'uitgesloten_ruimte',
    requestConfig: {
      headers: {
        'X-Strmln-Forced-Delete': true
      }
    },
    queryParams: true,
    path: ({ id }) => `/uitgesloten_ruimte/${id}`,
    onSuccess: deleteSuccess('uitgesloten_ruimte')
  })
  .get({
    action: 'GET_INVENTARISATIE_USER_CERTIFICATES',
    queryParams: true,
    property: 'inventarisatie_user_certificates',
    path: '/inventarisatie_user_certificate'
  })
  .get({
    action: 'GET_INVENTARISATIE_USER_CERTIFICATE',
    property: 'inventarisatie_user_certificate',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_user_certificate/${id}`
  })
  .post({
    action: 'CREATE_INVENTARISATIE_USER_CERTIFICATE',
    property: 'inventarisatie_user_certificate',
    path: '/inventarisatie_user_certificate',
    queryParams: true,
    onSuccess: createSuccess('inventarisatie_user_certificate', 'inventarisatie_user_certificates')
  })
  .post({
    action: 'UPDATE_INVENTARISATIE_USER_CERTIFICATE',
    property: 'inventarisatie_user_certificate',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_user_certificate/${id}`,
    onSuccess: updateSuccess('inventarisatie_user_certificate', 'inventarisatie_user_certificates')
  })
  .delete({
    action: 'DELETE_INVENTARISATIE_USER_CERTIFICATE',
    property: 'inventarisatie_user_certificate',
    requestConfig: { headers: { 'X-Strmln-Forced-Delete': true } },
    queryParams: true,
    path: ({ id }) => `/inventarisatie_user_certificate/${id}`,
    onSuccess: deleteSuccess('inventarisatie_user_certificate', 'inventarisatie_user_certificates')
  })

  .post({
    action: 'CREATE_INVENTARISATIE_USER_CAPABILITY_TOEWIJZING',
    property: 'inventarisatie_user_capability_toewijzing',
    path: '/inv_user_capability_toewijzing',
    queryParams: true,
    onSuccess: createSuccess('inventarisatie_user_capability_toewijzing', 'inventarisatie_user_capability_toewijzingen')
  })
  .delete({
    action: 'DELETE_INVENTARISATIE_USER_CAPABILITY_TOEWIJZING',
    property: 'inventarisatie_user_capability_toewijzing',
    requestConfig: { headers: { 'X-Strmln-Forced-Delete': true } },
    queryParams: true,
    path: ({ id }) => `/inv_user_capability_toewijzing/${id}`,
    onSuccess: deleteSuccess('inventarisatie_user_capability_toewijzing', 'inventarisatie_user_capability_toewijzingen')
  })

  .get({
    action: 'GET_UITRUSTINGEN',
    queryParams: true,
    property: 'uitrustingen',
    path: '/uitrusting'
  })
  .get({
    action: 'GET_UITRUSTING',
    property: 'uitrusting',
    queryParams: true,
    path: ({ id }) => `/uitrusting/${id}`
  })
  .post({
    action: 'CREATE_UITRUSTING',
    property: 'uitrusting',
    path: '/uitrusting',
    queryParams: true,
    onSuccess: createSuccess('uitrusting', 'uitrustingen')
  })
  .post({
    action: 'UPDATE_UITRUSTING',
    property: 'uitrusting',
    queryParams: true,
    path: ({ id }) => `/uitrusting/${id}`,
    onSuccess: updateSuccess('uitrusting', 'uitrustingen')
  })
  .delete({
    action: 'DELETE_UITRUSTING',
    property: 'uitrusting',
    requestConfig: { headers: { 'X-Strmln-Forced-Delete': true } },
    queryParams: true,
    path: ({ id }) => `/uitrusting/${id}`,
    onSuccess: deleteSuccess('uitrusting', 'uitrustingen')
  })

  .get({
    action: 'GET_UITRUSTING_CERTIFICATES',
    queryParams: true,
    property: 'uitrusting_certificates',
    path: '/uitrusting_certificaat'
  })
  .get({
    action: 'GET_UITRUSTING_CERTIFICATE',
    property: 'uitrusting_certificate',
    queryParams: true,
    path: ({ id }) => `/uitrusting_certificaat/${id}`
  })
  .post({
    action: 'CREATE_UITRUSTING_CERTIFICATE',
    property: 'uitrusting_certificate',
    path: '/uitrusting_certificaat',
    queryParams: true,
    onSuccess: createSuccess('uitrusting_certificate', 'uitrusting_certificates')
  })
  .post({
    action: 'UPDATE_UITRUSTING_CERTIFICATE',
    property: 'uitrusting_certificate',
    queryParams: true,
    path: ({ id }) => `/uitrusting_certificaat/${id}`,
    onSuccess: updateSuccess('uitrusting_certificate', 'uitrusting_certificates')
  })
  .delete({
    action: 'DELETE_UITRUSTING_CERTIFICATE',
    property: 'uitrusting_certificate',
    requestConfig: { headers: { 'X-Strmln-Forced-Delete': true } },
    queryParams: true,
    path: ({ id }) => `/uitrusting_certificaat/${id}`,
    onSuccess: deleteSuccess('uitrusting_certificate', 'uitrusting_certificates')
  })
  .getStore()

inventarisatie.mutations.RESET_INVENTARISATIE_STATE = (state) => {
  const initial = initialState()
  for (const key in initial) {
    if (Object.prototype.hasOwnProperty.call(initial, key)) {
      state[key] = initial[key]
    }
  }
}

export default inventarisatie
